import { merge, omit } from 'lodash';

import { LOGIN_WIDGET_USER, SIGN_IN, VALIDATE_TOKEN, FETCH_CURRENT_USER } from '@lib/actions/actionTypes';
import { getType } from 'typesafe-actions';
import { initApp } from '@lib/actions';
import { getTokenData } from 'utils/getTokenData';

const initialState = {
  ready: false,
  user: undefined,
  master: undefined,
};

export default function createAuthReducer() {
  return (state = initialState, action) => {
    switch (action.type) {
      // SIGN_IN / SIGN_OUT
      case SIGN_IN.REQUEST:
        return initialState;
      case SIGN_IN.SUCCESS: {
        return merge({}, state, {
          user: action.data._id,
        });
      }
      // LOGGING WIDGET USER
      case LOGIN_WIDGET_USER.SUCCESS: {
        return merge({}, state, {
          user: getTokenData(action.data.token)?.iss,
          // Store the widget user in the Redux store
          widgetUser: {
            _id: action.meta?.requestAction?.id,
            ...omit(action.data, ['token']),
          },
        });
      }
      // VALIDATE_TOKEN
      case VALIDATE_TOKEN.SUCCESS:
        return merge({}, state, {
          user: action.normalized.result,
          prevUser: state.user,
        });
      // FETCH_CURRENT_USER
      case FETCH_CURRENT_USER.SUCCESS:
        return merge({}, state, {
          user: action.data._id,
          master: action.data.user,
        });
      // initApp.success
      case getType(initApp.success):
        return merge({}, state, action.payload, { ready: true });
      default:
        return state;
    }
  };
}
